"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.codeFrameToString = exports.stackToString = exports.buildLogTransport = void 0;
const BatchLogProcessor_1 = require("./BatchLogProcessor");
const BackendLogger_types_1 = require("./BackendLogger.types");
const lodash_1 = require("lodash");
const LoggerHelper_1 = require("./LoggerHelper");
const buildLogTransport = (options = {
    flushSize: 50,
    flushIntervalMs: 10000,
}) => {
    const batchLogProcessor = new BatchLogProcessor_1.BatchLogProcessor(options);
    return (logObject) => {
        const processedLogObject = preprocessLogObject(logObject);
        batchLogProcessor.write(processedLogObject);
    };
};
exports.buildLogTransport = buildLogTransport;
const preprocessLogObject = (logObject) => {
    var _a;
    const logObjectCopy = (0, lodash_1.cloneDeep)(logObject);
    // eslint-disable-next-line no-control-regex
    logObjectCopy.msg = (_a = logObjectCopy.msg) === null || _a === void 0 ? void 0 : _a.replace(/\u001b\[.*?m/g, ''); // remove styling from msg
    if (logObjectCopy.isError) {
        if (logObject.stackFrame) {
            if ((0, BackendLogger_types_1.isStackIStackFrame)(logObject.stackFrame)) {
                logObjectCopy.stackString = (0, exports.stackToString)(logObject.stackFrame);
            }
            else if ((0, BackendLogger_types_1.isStackString)(logObject.stackFrame)) {
                logObjectCopy.stackString = logObject.stackFrame;
            }
        }
        logObjectCopy.codeFrameString = (0, exports.codeFrameToString)(logObject.codeFrame);
    }
    return logObjectCopy;
};
const stackToString = (stack) => {
    // for sending logs to disk / kibana
    if (!stack)
        return 'No stack to show.';
    const outputHeader = 'Error stack:\n';
    const outputBody = stack
        .map((stackFrame) => {
        var _a;
        let stackFrameStr = '• ';
        if (stackFrame.fileName) {
            stackFrameStr += stackFrame.fileName;
        }
        if (stackFrame.lineNumber !== undefined) {
            stackFrameStr += `:${stackFrame.lineNumber}`;
        }
        stackFrameStr += ` ${(_a = stackFrame.functionName) !== null && _a !== void 0 ? _a : '<anonymous>'}`;
        if (stackFrame.filePath &&
            stackFrame.lineNumber !== undefined &&
            stackFrame.columnNumber !== undefined) {
            stackFrameStr += `(${stackFrame.filePath}:${stackFrame.lineNumber}:${stackFrame.columnNumber})`;
        }
        return stackFrameStr;
    })
        .join('\n');
    return outputHeader + outputBody;
};
exports.stackToString = stackToString;
const codeFrameToString = (codeFrame) => {
    // for sending logs to disk / kibana
    if (!codeFrame)
        return 'No code frame to show.';
    const outputHeader = 'Code frame:\n';
    let outputBeforeError = '';
    let lineNumber = codeFrame.firstLineNumber;
    codeFrame.linesBefore.forEach((line) => {
        outputBeforeError += `  ${LoggerHelper_1.LoggerHelper.lineNumberTo3Char(lineNumber)} | ${line}\n`;
        lineNumber++;
    });
    const outputAtError = `> ${LoggerHelper_1.LoggerHelper.lineNumberTo3Char(lineNumber)} | ${codeFrame.relevantLine}\n`;
    lineNumber++;
    let positionMarker = '\n';
    if (codeFrame.columnNumber != null) {
        positionMarker = new Array(codeFrame.columnNumber + 8).join(' ') + `^\n`;
    }
    let outputAfterError = '';
    codeFrame.linesAfter.forEach((line) => {
        outputAfterError += `  ${LoggerHelper_1.LoggerHelper.lineNumberTo3Char(lineNumber)} | ${line}\n`;
        lineNumber++;
    });
    return (outputHeader +
        outputBeforeError +
        outputAtError +
        positionMarker +
        outputAfterError);
};
exports.codeFrameToString = codeFrameToString;
//# sourceMappingURL=BuildLogTransport.js.map